import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/invoice/invoices', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/invoice/invoices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSuppliers() {
      return new Promise((resolve, reject) => {
        axios
          .get('/supplier')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCustomers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/customer', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProducts() {
      return new Promise((resolve, reject) => {
        axios
          .get('/product')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCash() {
      return new Promise((resolve, reject) => {
        axios
          .get('/cashmaster')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPurchase(queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/purchase', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCompany(queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/company', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchShipping(queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/shipping', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSales(queryParams, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`cashier/sales/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPreSales(queryParams, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`cashier/presales/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // addUser(ctx, userData) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post('/apps/user/users', { user: userData })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
  },
}
